<template>
    <section class="UpdateProfile" id="update-profile-page">
        <section class="section-pad Profile-forms">
            <el-row type="flex" justify="center">
                <el-col :lg="12" :xs="20">
                    <h3 class="form-title">Profile Details</h3>
                    <el-alert v-if="success_message" type="success" :title="success_message" class="mb-10"></el-alert>
                    <el-form ref="form" :model="update_profile" label-position="top">
                        <el-row :gutter="30">
                            <el-col :md="24">
                                <el-form-item label="Full Name">
                                    <el-input v-model="update_profile.name"></el-input>
                                    <span class="error" v-if="getErrors && getErrors.name">{{ getErrors.name }}</span>

                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="30">
                            <el-col :md="12">
                                <el-form-item label="Gender">
                                    <el-select v-model="update_profile.gender" placeholder="Select">
                                        <el-option value="Male">Male</el-option>
                                        <el-option value="Female">Female</el-option>
                                    </el-select>
                                    <span class="error" v-if="getErrors && getErrors.gender">{{ getErrors.gender }}</span>

                                </el-form-item>
                            </el-col>
                            <el-col :md="12">
                                <el-form-item label="Date Of Birth">
                                    <el-input v-model="update_profile.dob" placeholder="YYYY-MM-DD"></el-input>
                                    <span class="error" v-if="getErrors && getErrors.dob">{{ getErrors.dob }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-col :md="24">
                            <el-form-item>
                                <el-button
                                        type="primary"
                                        @click="onSubmit"
                                        :loading="loading"
                                        class="btn submit-btn"
                                >Update Profile
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-col>
            </el-row>
        </section>
    </section>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import LayoutDefault from "../../layouts/LayoutDefault";
    import moment from "moment";

    export default {
        data() {
            return {
                loading: false,
                success_message: '',
                update_profile: {
                    name: "",
                    gender: "",
                    dob: ""
                }
            };
        },
        computed: {
            ...mapGetters("errors", ["getErrors", "getMessage"]),
            ...mapGetters("profile", ["getProfile"]),
        },
        async created() {
            this.loading = true;
            this.$emit("update:layout", LayoutDefault);
            await this.profile();
            this.update_profile.name = this.getProfile.name;
            this.update_profile.dob = this.getProfile.dob;
            this.update_profile.gender = this.getProfile.gender;
            this.loading = false;
        },
        methods: {
            ...mapActions({
                profile: 'profile/getProfile'
            }),
            async onSubmit() {
                this.loading = true;
                await this.$store.dispatch("profile/updateProfile", this.update_profile);
                this.loading = false;

                if (this.getMessage) {
                    this.success_message = this.getMessage;
                }
            }
        }
    };
</script>


<style lang="scss">
</style>
